export const COLOR_TYPE = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    ACCENT: 'accent',
    SUCCESS: 'success',
    ERROR: 'error',
};

export class AppTheme {
    constructor(theme) {
        this.theme = theme;
    }

    getTheme() {
        return this.theme;
    }

    setTheme(theme) {
        this.themeName = theme;
    }

    getColor(colorName) {
        return this.theme[colorName];
    }
}
